import { PortWidget } from '@projectstorm/react-diagrams'
import { FC } from 'react'

interface DuprNodeWidgetProps {
  node: any
  engine: any
}

const DuprNodeWidget: FC<DuprNodeWidgetProps> = ({ node, engine }) => {
  return (
    <div
      style={{
        height: node.height || 41.25,
        width: node.width || 300,
      }}
      className={`${
        !node?.disabled ? `border-3 border-solid rounded ${node.isSelected() ? 'border-warning' : 'border-dark'}` : ''
      }`}
    >
      <div
        style={{
          top: node.height / 2 || 21,
        }}
        className="absolute z-10 left-0"
      >
        <PortWidget engine={engine} port={node.getPort(`${node.direction === 'left' ? 'out' : 'in'}`)} />
      </div>
      <div>{node.card}</div>
      <div
        style={{
          left: node.width || 300,
          top: node.height / 2 || 21,
        }}
        className="absolute z-10"
      >
        <PortWidget engine={engine} port={node.getPort(`${node.direction === 'left' ? 'in' : 'out'}`)} />
      </div>
    </div>
  )
}

export default DuprNodeWidget
